import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import {Message} from '../../../_metronic/helpers'
import {
  addSalaryStructure,
  deleteSalaryStructures,
  getSalaryStructures,
  getSalaryStructuresById,
  updateSalaryStructureById,
} from '../../../api/SalaryStructureAPI'
import {DELETE_MESSAGE, UPDATE_MESSAGE} from '../../../utils/contants'
import {AlertProps} from '../../data/AlertDefaults'

export const getSalaryStructure = (setSalaryStructure: Function, setAPIStatus: Function) => {
  setAPIStatus((prev: any) => ({...prev, loading: true}))
  getSalaryStructures().then((res: any) => {
    if (res.statusCode === 200) {
      const salarystructuresWithIndex = res.data.map((salarystructure: any, index: number) => ({
        ...salarystructure,
        index: index + 1,
      }))
      setSalaryStructure(salarystructuresWithIndex)
      setSalaryStructure(res.data)

      setAPIStatus((prev: any) => ({...prev, loading: false}))
    } else {
      setAPIStatus((prev: any) => ({...prev, loading: false, error: res.message}))
    }
  })
}

// form save function

export const handleSubmit = (
  InputField: {
    salaryStructureName: string
    basic: boolean
    HRA: boolean
    DA: boolean
    education: boolean

    LTA: boolean
    specialAllowance: boolean
    variable: boolean
    telephoneAndInternetReimbursement: boolean
    carAndDriverReimbursement: boolean
    mealCoupon: boolean
    booksAndPeriodicals: boolean
    PF: boolean
    PT: boolean
    ESIC: boolean
    LWF: boolean
  },
  getSalaryStructure: Function,
  setSalaryStructure: Function,
  setEditId: Function,
  initialState: {
    salaryStructureName: string
    basic: boolean
    HRA: boolean
    DA: boolean
    education: boolean

    LTA: boolean
    specialAllowance: boolean
    variable: boolean
    telephoneAndInternetReimbursement: boolean
    carAndDriverReimbursement: boolean
    mealCoupon: boolean
    booksAndPeriodicals: boolean
    PF: boolean
    PT: boolean
    ESIC: boolean
    LWF: boolean
  },
  setInputField: Function,
  editId: string | null,
  cancelSubmit: Function,
  setAPIStatus: Function,
  setInputError: Function,
  validateForm: Function,
  setSubmitAPIStatus: Function,
  setIsAddUserModalOpen: Function,
  setIsEditModalOpen: Function
) => {
  let {cnt, error} = validateForm(InputField)
  setInputError(error)

  if (cnt === 0) {
    if (editId == null) {
      setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
      addSalaryStructure(InputField).then((res) => {
        if (res.statusCode === 200) {
          toast.success(res.message)
          getSalaryStructure(setSalaryStructure, setAPIStatus)
          cancelSubmit(setInputField, initialState, setEditId, setInputError)
          setIsAddUserModalOpen(false)
          setIsEditModalOpen(false)
        } else {
          Message(res.message, 'error')
        }
        setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
      })
    } else {
      Swal.fire({...AlertProps, icon: 'warning', title: UPDATE_MESSAGE}).then((result: any) => {
        if (result.isConfirmed) {
          setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
          updateSalaryStructureById(InputField, editId).then((res: any) => {
            if (res.statusCode === 200) {
              getSalaryStructure(setSalaryStructure, setAPIStatus)
              toast.success(res.message)
              cancelSubmit(setInputField, initialState, setEditId, setInputError)
              setEditId(null)
              setIsAddUserModalOpen(false)
            } else {
              Message(res.message, 'error')
            }
            setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
          })
        }
      })
    }
  }
}

// delete salarystructure

export const deleteSalaryStructure = (
  id: string,
  getSalaryStructure: Function,
  setSalaryStructure: Function,
  setAPIStatus: Function,
  cancelSubmit: Function,
  setInputField: Function,
  InputField: {
    salaryStructureName: string
    basic: boolean
    HRA: boolean
    DA: boolean
    education: boolean

    LTA: boolean
    specialAllowance: boolean
    variable: boolean
    telephoneAndInternetReimbursement: boolean
    carAndDriverReimbursement: boolean
    mealCoupon: boolean
    booksAndPeriodicals: boolean
    PF: boolean
    PT: boolean
    ESIC: boolean
    LWF: boolean
  },
  setEditId: Function,

  setInputError: Function
) => {
  cancelSubmit(setInputField, InputField, setEditId, setInputError)
  Swal.fire({...AlertProps, icon: 'warning', title: DELETE_MESSAGE}).then((result: any) => {
    if (result.isConfirmed) {
      deleteSalaryStructures(id)
        .then((res: any) => {
          if (res.statusCode === 200) {
            getSalaryStructure(setSalaryStructure, setAPIStatus)
            toast.success(res.message)
          } else {
            Message(res.message, 'error')
          }
        })
        .catch((res: any) => {
          Message(res.message, 'error')
        })
    }
  })
}

export const handleInputChange = (
  event: React.SyntheticEvent,
  setInputField: Function,
  InputField: {
    salaryStructureName: string
    basic: boolean
    HRA: boolean
    DA: boolean
    education: boolean

    LTA: boolean
    specialAllowance: boolean
    variable: boolean
    telephoneAndInternetReimbursement: boolean
    carAndDriverReimbursement: boolean
    mealCoupon: boolean
    booksAndPeriodicals: boolean
    PF: boolean
    PT: boolean
    ESIC: boolean
    LWF: boolean
  }
) => {
  let target = event.target as HTMLInputElement
  setInputField({
    ...InputField,
    [target.name]: target.type === 'checkbox' ? target.checked : target.value,
  })
}

//getSalaryStructureByID

export const getSalaryStructureById = (
  id: string,
  InputField: {
    salaryStructureName: string
    basic: boolean
    HRA: boolean
    DA: boolean
    education: boolean

    LTA: boolean
    specialAllowance: boolean
    variable: boolean
    telephoneAndInternetReimbursement: boolean
    carAndDriverReimbursement: boolean
    mealCoupon: boolean
    booksAndPeriodicals: boolean
    PF: boolean
    PT: boolean
    ESIC: boolean
    LWF: boolean
  },
  setInputField: Function,
  setEditId: Function,
  setInputError: Function
) => {
  getSalaryStructuresById(id).then((res: any) => {
    if (res) {
      setInputField({
        ...InputField,
        salaryStructureName: res.data.salaryStructureName,
        basic: res.data.basic,
        HRA: res.data.HRA,
        DA: res.data.DA,
        education: res.data.education,
        LTA: res.data.LTA,
        specialAllowance: res.data.specialAllowance,
        variable: res.data.variable,
        telephoneAndInternetReimbursement: res.data.telephoneAndInternetReimbursement,
        carAndDriverReimbursement: res.data.carAndDriverReimbursement,
        mealCoupon: res.data.mealCoupon,
        booksAndPeriodicals: res.data.booksAndPeriodicals,
        PF: res.data.PF,
        PT: res.data.PT,
        ESIC: res.data.ESIC,
        LWF: res.data.LWF,
      })
      setEditId(id)
      setInputError({})
      window.scrollTo(0, 0)
    } else {
      Message(res.message, 'error') // Assuming the Message function is imported from the correct location
    }
  })
}
export const validateForm = (InputField: {
  salaryStructureName: string
  basic: boolean
  HRA: boolean
  DA: boolean
  education: boolean
  LTA: boolean
  specialAllowance: boolean
  variable: boolean
  telephoneAndInternetReimbursement: boolean
  carAndDriverReimbursement: boolean
  mealCoupon: boolean
  booksAndPeriodicals: boolean
  PF: boolean
  PT: boolean
  ESIC: boolean
  LWF: boolean
}) => {
  let cnt = 0
  const error: any = {}
  const trimmedBand = InputField.salaryStructureName.trim()
  if (!trimmedBand) {
    cnt = cnt + 1
    error.salaryStructureName = 'Please enter Salary Structure Name.'
  }
  const trimmedPT = InputField.PT.valueOf()
  if (!trimmedPT) {
    cnt = cnt + 1
    error.basic = 'PT should be checked.'
  }
  const trimmedPF = InputField.PF.valueOf()
  if (!trimmedPF) {
    cnt = cnt + 1
    error.basic = 'PF should be checked.'
  }
  const trimmedSpeAll = InputField.specialAllowance.valueOf()
  if (!trimmedSpeAll) {
    cnt = cnt + 1
    error.basic = 'Special Allowance should be checked.'
  }
  const trimmedDA = InputField.DA.valueOf()
  if (!trimmedDA) {
    cnt = cnt + 1
    error.basic = 'DA should be checked.'
  }
  const trimmedHRA = InputField.HRA.valueOf()
  if (!trimmedHRA) {
    cnt = cnt + 1
    error.basic = 'HRA should be checked.'
  }
  const trimmedBasic = InputField.basic.valueOf()
  if (!trimmedBasic) {
    cnt = cnt + 1
    error.basic = 'Basic should be checked.'
  }
  return {error, cnt}
}

export const cancelSubmit = (
  setInputField: Function,
  InputField: {
    salaryStructureName: string
    basic: boolean
    HRA: boolean
    DA: boolean
    education: boolean
    LTA: boolean
    specialAllowance: boolean
    variable: boolean
    telephoneAndInternetReimbursement: boolean
    carAndDriverReimbursement: boolean
    mealCoupon: boolean
    booksAndPeriodicals: boolean
    PF: boolean
    PT: boolean
    ESIC: boolean
    LWF: boolean
  },
  setEditId: Function,
  setInputError: Function
) => {
  setEditId(null)
  setInputField(InputField)
  setInputError({})
}
